// ChatMemberadd.js

import React, { useState } from "react";
import {
    Button, ModalBody, ModalFooter, ModalHeader,
    Modal, ModalOverlay, ModalContent, CloseButton
} from "@chakra-ui/react";
import { Select } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../Redux";
import toast from "react-hot-toast";
import { API } from "../../Services";

const { Option } = Select;

export default function ChatMemberadd({
    isAddMemberOpen,
    setIsAddMemberOpen,
    chatdata,
  }) {
    const state = useSelector((state) => state);
    const dispatch = useDispatch();
     const { trelloCardInfo,trelloCommentList} = bindActionCreators(actionCreators, dispatch);
    const [selectedMemberId, setSelectedMemberId] = useState([]);
    const [isAssigning, setIsAssigning] = useState(false);
    const projectID = chatdata?.projectCode ? chatdata?.projectCode : chatdata?.orderCode;

    const AddSelectedMember = () => {
        const memberIDs = selectedMemberId.map((d) => d.value);
        const data = { memberID: memberIDs };
        setIsAssigning(true);
        API.addMemberChatList(projectID, data)
            .then((res) => {
                toast.success(res.data.message || "Member Added successfully.", {
                    position: "top-right",
                });
                trelloCardInfo(projectID);
                trelloCommentList(projectID, 20, 1);
                setIsAddMemberOpen(false);
                setSelectedMemberId([]);
            })
            .catch(() => {
                toast.error("Oops! Failed to Add Member.", {
                    position: "top-right",
                });
                setIsAddMemberOpen(false);
            })
            .finally(() => setIsAssigning(false));
    };

    return (
        <Modal isOpen={isAddMemberOpen} onClick={() => setIsAddMemberOpen(false)} >
            <ModalOverlay />
            <ModalContent maxH="38rem" minH="15rem">
                <ModalHeader display="flex" justifyContent="space-between">
                    Assign Chat Members
                    <CloseButton onClick={() => setIsAddMemberOpen(false)}/>
                </ModalHeader>
                <ModalBody>
                    <span>Select Members</span>
                    <Select
                        showSearch
                        mode="multiple"
                        size="middle"
                        labelInValue
                        placeholder="Please Select Members name"
                        onChange={(data) => setSelectedMemberId(data)}
                        style={{ width: "100%" }}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {state.admins.admins.map((member) => (
                            <Option value={member?.admin_id} key={member?.admin_id}>
                                {member?.admin_firstname + " " + member?.admin_lastname}
                            </Option>
                        ))}
                    </Select>
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={AddSelectedMember}
                        isLoading={isAssigning}
                        size="sm"
                        style={{ marginRight: "8px" }}
                    >
                        Add
                    </Button>
                    <Button onClick={() => setIsAddMemberOpen(false)}  size="sm">
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
